export const TAB = 9;
export const ESC = 27;
export const ENTER = 13;
export const ARROW_UP = 38;
export const ARROW_DOWN = 40;
